module.exports = __webpack_public_path__ + "img/location1_opt.96cbedbb.jpg";